//トップページ
export function homeFunc() {
  // Splide（ライブラリ）
  // eslint-disable-next-line global-require
  const Splide = require("@splidejs/splide").default;

  const equalizeSlideCardHeights = (root) => {
    const cards = Array.from(root.querySelectorAll(".splide__slide:not(.splide__slide--clone) .c-card-post"));
    if (cards.length === 0) return;

    cards.forEach((card) => {
      card.style.removeProperty("height");
    });

    const max = cards.reduce((height, card) => Math.max(height, card.offsetHeight), 0);
    if (max > 0) {
      cards.forEach((card) => {
        card.style.height = `${max}px`;
      });
    }
  };

  const initKv = () => {
    const root = document.querySelector('[data-slider="kv"]');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll(".splide__slide"));
    if (slides.length === 0) return;

    const trackEl = root.querySelector(".splide__track");
    const slideEls = slides;
    const pagination = root.querySelector(".p-home-kv__pagination");
    const prevBtn = root.querySelector(".p-home-kv__arrow.is-prev");
    const nextBtn = root.querySelector(".p-home-kv__arrow.is-next");

    const splide = new Splide(root, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: "0px",
      pagination: false,
      arrows: false,
      autoplay: false,
      focus: "center",
      fixedWidth: "calc(100% - 80px)", // 左右40pxずつ余白を作って隣を見せる
      speed: 600,
      easing: "ease",
      drag: true,
      breakpoints: {
        659: {
          fixedWidth: "100%", // 659px以下は左右を見せない
          gap: "30px",
        },
      },
    });

    const lockTrackHeight = () => {
      if (!trackEl || slideEls.length === 0) return;
      const max = slideEls.reduce((acc, el) => Math.max(acc, el.offsetHeight), 0);
      if (max > 0) trackEl.style.height = `${max}px`;
    };

    // 659px以下で表示する矢印（loopなので端判定は不要）
    if (prevBtn && nextBtn) {
      prevBtn.classList.remove("is-hidden");
      nextBtn.classList.remove("is-hidden");
      prevBtn.addEventListener("click", () => splide.go("<"));
      nextBtn.addEventListener("click", () => splide.go(">"));
    }

    const paginationButtons = pagination
      ? slides.map((_, index) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "p-home-kv__pagination-button";
        button.setAttribute("aria-label", `スライド ${index + 1}`);
        button.addEventListener("click", () => splide.go(index));
        pagination.appendChild(button);
        return button;
      })
      : [];

    const updatePagination = () => {
      paginationButtons.forEach((button, index) => {
        const isActive = index === splide.index;
        button.setAttribute("aria-current", isActive ? "true" : "false");
        button.classList.remove("is-active");
      });

      const activeButton = paginationButtons[splide.index];
      if (activeButton) {
        // 一度レイアウトを確定させて、同じボタンでも進捗アニメーションを先頭から再生する
        void activeButton.offsetHeight;
        activeButton.classList.add("is-active");
      }
    };

    pagination?.addEventListener("animationend", (e) => {
      if (e.animationName !== "p-home-kv-pagination-progress") return;
      if (!e.target.classList.contains("is-active")) return;
      splide.go(">");
    });

    const updateKv = () => {
      equalizeSlideCardHeights(root);
      lockTrackHeight();
      updatePagination();
    };

    splide.on("mounted", updateKv);
    splide.on("moved", updateKv);
    splide.on("updated", updateKv);
    splide.on("resized", updateKv);

    splide.mount();
  };

  const initRecommend = () => {
    const root = document.querySelector('[data-slider="recommend"]');
    if (!root) return;

    const prevBtn = root.querySelector(".p-home-recommend__arrow.is-prev");
    const nextBtn = root.querySelector(".p-home-recommend__arrow.is-next");
    if (!prevBtn || !nextBtn) return;

    const trackEl = root.querySelector(".splide__track");
    const slideEls = Array.from(root.querySelectorAll(".splide__slide"));

    const splide = new Splide(root, {
      type: "slide",
      perPage: 3,
      perMove: 1,
      gap: "32px",
      pagination: false,
      arrows: false,
      speed: 400,
      easing: "ease",
      breakpoints: {
        1279: { perPage: 2 },
        639: { perPage: 1 },
      },
    });

    const setButtons = () => {
      const atStart = splide.index <= 0;
      const atEnd = splide.index >= splide.Components.Controller.getEnd();
      prevBtn.classList.toggle("is-hidden", atStart);
      nextBtn.classList.toggle("is-hidden", atEnd);
    };

    const lockTrackHeight = () => {
      if (!trackEl || slideEls.length === 0) return;
      const max = slideEls.reduce((acc, el) => Math.max(acc, el.offsetHeight), 0);
      if (max > 0) trackEl.style.height = `${max}px`;
    };

    prevBtn.addEventListener("click", () => splide.go("<"));
    nextBtn.addEventListener("click", () => splide.go(">"));

    const updateUi = () => {
      equalizeSlideCardHeights(root);
      setButtons();
      lockTrackHeight();
    };

    splide.on("mounted", updateUi);
    splide.on("moved", updateUi);
    splide.on("updated", updateUi);
    splide.on("resized", updateUi);

    splide.mount();
  };

  const initNewList = () => {
    const root = document.querySelector('[data-slider="new"]');
    if (!root) return;

    const prevBtn = root.querySelector(".p-home-recommend__arrow.is-prev");
    const nextBtn = root.querySelector(".p-home-recommend__arrow.is-next");
    if (!prevBtn || !nextBtn) return;

    const trackEl = root.querySelector(".splide__track");
    let slideEls = [];
    const mql = window.matchMedia("(max-width: 1279px)");
    let splide = null;

    const lockTrackHeight = () => {
      if (!trackEl || slideEls.length === 0) return;
      const max = slideEls.reduce((acc, el) => Math.max(acc, el.offsetHeight), 0);
      if (max > 0) trackEl.style.height = `${max}px`;
    };

    const mount = () => {
      if (!mql.matches || splide) return;
      slideEls = Array.from(root.querySelectorAll(".splide__slide"));

      splide = new Splide(root, {
        type: "slide",
        perPage: 2,
        perMove: 1,
        gap: "32px",
        pagination: false,
        arrows: false,
        speed: 400,
        easing: "ease",
        breakpoints: {
          659: { perPage: 1 },
        },
      });

      const setButtons = () => {
        const atStart = splide.index <= 0;
        const atEnd = splide.index >= splide.Components.Controller.getEnd();
        prevBtn.classList.toggle("is-hidden", atStart);
        nextBtn.classList.toggle("is-hidden", atEnd);
      };

      const updateUi = () => {
        equalizeSlideCardHeights(root);
        setButtons();
        lockTrackHeight();
      };

      prevBtn.addEventListener("click", () => splide && splide.go("<"));
      nextBtn.addEventListener("click", () => splide && splide.go(">"));

      splide.on("mounted", updateUi);
      splide.on("moved", updateUi);
      splide.on("updated", updateUi);
      splide.on("resized", updateUi);

      splide.mount();
    };

    const destroy = () => {
      if (mql.matches || !splide) return;
      splide.destroy(true);
      splide = null;
      slideEls = [];
      root.querySelectorAll(".c-card-post").forEach((card) => {
        card.style.removeProperty("height");
      });
      if (trackEl) trackEl.style.removeProperty("height");
      prevBtn.classList.add("is-hidden");
      nextBtn.classList.add("is-hidden");
    };

    const onChange = () => {
      destroy();
      mount();
    };

    // initial
    onChange();

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onChange);
    } else {
      mql.addListener(onChange);
    }
  };

  const initHomeArticleLoadMore = () => {
    const list = document.querySelector("[data-home-article-list]");
    const button = document.querySelector("[data-home-article-more]");
    const settings = window.creiaHomeArticles;
    if (!list || !button || !settings || !settings.ajaxUrl || !settings.nonce) return;

    const buttonText = button.querySelector("span");
    const buttonWrap = button.closest(".p-home-article__more");
    const defaultText = buttonText ? buttonText.textContent : "";
    let isLoading = false;
    const spMql = window.matchMedia("(max-width: 639px)");

    const setText = (text) => {
      if (buttonText) buttonText.textContent = text;
    };

    const getPerPage = () => (spMql.matches ? 6 : 12);

    const hideButton = () => {
      finishLoading();
      if (buttonWrap) {
        buttonWrap.hidden = true;
        buttonWrap.classList.add("is-hidden");
        buttonWrap.style.display = "none";
      } else {
        button.hidden = true;
        button.classList.add("is-hidden");
        button.style.display = "none";
      }
    };

    const finishLoading = (shouldRestoreText = true) => {
      isLoading = false;
      button.disabled = false;
      button.removeAttribute("aria-busy");
      if (shouldRestoreText) setText(defaultText);
    };

    button.addEventListener("click", () => {
      if (isLoading) return;

      const offset = list.children.length;
      if (offset < 1) {
        hideButton();
        return;
      }

      isLoading = true;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      setText("読み込み中");

      const requestBody = [
        ["action", "creia_load_home_articles"],
        ["nonce", settings.nonce],
        ["offset", String(offset)],
        ["per_page", String(getPerPage())],
      ]
        .map((item) => `${encodeURIComponent(item[0])}=${encodeURIComponent(item[1])}`)
        .join("&");

      const showError = () => {
        setText("読み込みに失敗しました");
        finishLoading(false);
        window.setTimeout(() => {
          setText(defaultText);
        }, 1800);
      };

      const request = new XMLHttpRequest();
      request.open("POST", settings.ajaxUrl, true);
      request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
      request.onreadystatechange = () => {
        if (request.readyState !== 4) return;
        if (request.status < 200 || request.status >= 300) {
          showError();
          return;
        }

        let result = null;
        try {
          result = JSON.parse(request.responseText);
        } catch (error) {
          showError();
          return;
        }

        if (!result || !result.success || !result.data) {
          showError();
          return;
        }

        if (result.data.html) {
          list.insertAdjacentHTML("beforeend", result.data.html);
        }

        if (!result.data.html) {
          hideButton();
          return;
        }

        const nextOffset = parseInt(result.data.nextOffset || list.children.length, 10);
        button.dataset.nextOffset = String(nextOffset);

        if (!result.data.hasMore) {
          hideButton();
        }

        finishLoading();
      };
      request.onerror = showError;
      request.send(requestBody);
    });
  };

  initKv();
  initRecommend();
  initNewList();
  initHomeArticleLoadMore();
}
